import React, { useState, useEffect } from 'react';
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import './Privacy.css'


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation, BsTransparency } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Privacy = () => {
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isDashModalOpen, setIsDashModalOpen] = useState(false);


    const goals = [
        {
            goal: 'Privacy Standard compliance',
            PreGoal:'Goal PS1:',
            description: 'AI systems are designed to protect privacy in accordance with the legal and regulatory requirements of the geographic jurisdictions within which they are deployed and within the geographic jurisdictions from which training, testing and validation data has been sourced. Additionally, they should follow international standards and aim to meet potential customer criteria (normally based on the legal and regulatory requirements and national and international standards). The main privacy goals to be built into AI systems are outlined below, along with details on how they are used:',
            appliesTo: 'Legal and Regulatory requirements are present and/or where the customer has specific criteria set out in a privacy policy (and supporting procedures)',
            requirements: [
                {
                    id: 'Data Minimization:',
                    text: 'Minimize the collection, storage, and processing of personal data to the extent necessary for achieving the intended purpose.',
                    text2: 'AI systems should only collect and retain the minimum amount of data required to fulfil their functions, reducing the risk of privacy breaches and limiting exposure to potential misuse.'
                    
                },
                {
                    id: 'Purpose Limitation:',
                    text: 'Limit the use of personal data to specific, legitimate purposes disclosed to the data subjects at the time of collection.',
                    text2: 'AI systems should process personal data only for the purposes for which it was collected or consented to by the individuals, ensuring transparency and accountability in data processing activities.'
                    
                },
                {
                    id: 'Data Accuracy and Integrity:',
                    text: 'Ensure the accuracy, completeness, and integrity of personal data processed by AI systems.',
                    text2: "AI systems should employ measures to maintain data accuracy and integrity, such as data validation, verification, and correction mechanisms, to prevent inaccuracies and errors that could impact individuals' rights and interests."
                    
                },
                {
                    id: 'User Consent and Control:',
                    text: 'Obtain informed consent from individuals for the collection, use, and sharing of their personal data and provide them with control over their data.',
                    text2: 'AI systems should incorporate mechanisms for obtaining explicit consent from users for data processing activities and offer options for users to manage their privacy preferences, access, rectify, or delete their data.'
                    
                },
                {
                    id: 'Transparency and Accountability:',
                    text: 'Ensure transparency in AI system operations, decision-making processes, and data processing activities, and establish accountability for compliance with privacy laws and regulations.',
                    text2: 'AI systems should provide users with clear and accessible information about how their data is collected, used, and shared, as well as the purposes and implications of AI-driven decisions. Organizations should implement measures to monitor, audit, and demonstrate compliance with privacy requirements, fostering trust and accountability.'
                    
                },
                {
                    id: 'Security Safeguards:',
                    text: 'Implement robust security measures to protect personal data against unauthorized access, disclosure, alteration, or destruction.',
                    text2: 'AI systems should incorporate security safeguards, such as encryption, access controls, authentication mechanisms, and regular security assessments, to safeguard personal data from cyber threats, data breaches, and unauthorized use.'
                    
                },
                {
                    id: 'Fairness and Non-discrimination:',
                    text: 'Ensure that AI systems do not perpetuate biases, discrimination, or unfair treatment against individuals or groups based on protected characteristics.',
                    text2: 'AI systems should be designed, trained, and evaluated to mitigate biases and ensure fairness in decision-making processes, such as algorithmic assessments, recommendations, and predictions, to promote equal treatment and non-discrimination.'
                    
                },
                {
                    id: 'Data Subject Rights:',
                    text: 'Respect and facilitate the exercise of data subject rights, including the right to access, rectify, erase, and restrict the processing of personal data.',
                    text2: 'AI systems should provide mechanisms for individuals to exercise their data rights effectively, such as user-friendly interfaces for data access requests, data portability, and consent management, enabling individuals to assert control over their personal data.'
                    
                },
            ]
        },
        {
            goal: 'Security Policy compliance',
            PreGoal:'Goal PS2:',
            description: 'AI systems are designed to be secure in accordance with legal and regulatory requirements alongside any requirements set out by the customer.',
            appliesTo: 'Legal and Regulatory requirements are present and/or the Customer has a defined set of security requirements or standard that must be followed',
            text3: 'Overall Security Requirements should be focussed on:',
            requirements: [
                {
                    id: 'Data Security:',
                    subRequirements2: [
                        "Data Encryption: Encrypt sensitive data at rest and in transit to prevent unauthorized access.",
                        "Access Controls: Implement access controls to restrict data access to authorized users and roles.",
                        "Data Minimization: Minimize the collection and retention of sensitive data to reduce the attack surface.",
                        "Data Integrity: Ensure the integrity of data by implementing measures to detect and prevent data tampering.",
                    ],
                    
                },
                {
                    id: 'Model Security:',
                    subRequirements2: [
                        "Model Encryption: Encrypt trained models to protect intellectual property and prevent model theft.",
                        "Model Versioning: Maintain version control of models to track changes and ensure reproducibility.",
                        "Model Validation: Validate models for accuracy, fairness, and robustness to mitigate risks of biased or inaccurate predictions.",
                        "Model Auditing: Conduct regular audits of models to detect and mitigate vulnerabilities and ensure compliance with security standards.",
                    ],
                    
                },
                {
                    id: 'Access Control and Authentication:',
                    subRequirements2: [
                        "User Authentication: Implement strong authentication mechanisms, such as multi-factor authentication (MFA), to verify the identities of users.",
                        "Role-based Access Control (RBAC): Assign roles and permissions to users based on their responsibilities and privileges.",
                        "API Security: Secure APIs used for accessing and interacting with AI systems through authentication, authorization, and encryption.",
                        "Session Management: Manage user sessions securely to prevent session hijacking and unauthorized access.",
                    ],
                    
                },
                {
                    id: 'Network Security:',
                    subRequirements2: [
                        "Firewalls and Intrusion Detection Systems (IDS): Deploy firewalls and IDS to monitor and control network traffic and detect suspicious activities.",
                        "Secure Communication Protocols: Use secure communication protocols (e.g., HTTPS, SSL/TLS) to protect data transmission between AI systems and other components.",
                        "Network Segmentation: Segment networks to isolate AI systems from other systems and restrict communication to authorized entities.",
                    ],
                    
                },
                {
                    id: 'System and Software Security:',
                    subRequirements2: [
                        "Secure Coding Practices: Follow secure coding practices to mitigate common vulnerabilities, such as buffer overflows and injection attacks.",
                        "Patch Management: Keep AI system software and dependencies up to date with security patches to address known vulnerabilities.",
                        "Vulnerability Scanning and Penetration Testing: Conduct regular vulnerability assessments and penetration testing to identify and remediate security weaknesses.",
                        "Secure Configuration Management: Configure AI systems securely, disabling unnecessary services and applying least privilege principles.",
                    ],
                    
                },
                {
                    id: 'Incident Response and Recovery:',
                    subRequirements2: [
                        "Incident Response Plan: Develop an incident response plan outlining procedures for detecting, responding to, and recovering from security incidents.",
                        "Logging and Monitoring: Implement logging and monitoring mechanisms to track system activities, detect anomalies, and investigate security incidents.",
                        "Backup and Disaster Recovery: Establish backup and disaster recovery processes to ensure data integrity and system availability in the event of a security breach or system failure.",
                    ],
                    
                },
                {
                    id: 'Regulatory Compliance::',
                    subRequirements2: [
                        "Data Protection Regulations: Ensure compliance with data protection regulations (e.g., GDPR, CCPA) by implementing appropriate security measures for protecting personal data processed by AI systems.",
                        "Industry Standards: Adhere to industry-specific security standards and best practices relevant to AI systems (e.g., NIST, ISO/IEC 27001) to demonstrate due diligence and compliance.",

                    ],
                    
                },

            ]
        },
    ];
 

  // Modal component
  const DashModal = ({ isOpen, onClose, selectedGroup }) => {
    if (!isOpen || !selectedGroup) return null;
  
    // Fetch the specific goal data based on `selectedGroup`
    const goalData = goals.find(goal => goal.goal === selectedGroup);
  
    if (!goalData) return null;
  
    return (
      <div className="dashModal">
        <div className="dashModalContent">
          <div className="dashModalBox">
            {/* Title Section */}
            <h2 className="goal-title">
              <span className="goal-prefix">{goalData.PreGoal}</span> <span className="Priv-goal-name">{goalData.goal}</span>
            </h2>
            <p className="applies-to">{goalData.description}</p>
            <p className="applies-to"><i>Applies when:</i> {goalData.appliesTo}</p>
            <p className="applies-to">{goalData.text3}</p>
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="assessment-table">
                <thead>
                  <tr>
                    <th className="Priv-requirements-header">Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {goalData.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                      <td className="requirement-text">
                        <strong>{requirement.id}</strong> 
                        {requirement.text && requirement.text.length > 0 && (
                            <>
                            <br/> <strong>Goal: </strong>{requirement.text}
                            </>
                        )}
                         {requirement.text2 && requirement.text2.length > 0 && (
                            <>
                            <br/><strong>Usage: </strong>{requirement.text2}
                            </>
                        )}
                        {requirement.subRequirements2 && (
                            <ul className="sub-requirements2-list">
                            {requirement.subRequirements2.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
  
            {/* Close Button */}
            <button className="Priv-closeButton" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  };
  


  // Handle modal opening
  const openModal = (group) => {
    console.log(`Opening modal for: ${group}`);
    setSelectedGroup(group);
    setIsDashModalOpen(true);
  };

  const closeModal = () => {
    setIsDashModalOpen(false);
    setSelectedGroup(null);
  };

  


  return (
    <div style={{backgroundColor: 'rgb(240, 242, 245)', height: '100vh'}}>
      <div className='dashcontent'>
        <div>
          <h2>Privacy & Security Goals</h2>
        </div>
        <div className="Privacy-container">
          <div className="stats-box" onClick={() => openModal('Privacy Standard compliance')}>
            <div className="icon-box black">
              <PiStrategyBold />
            </div>
            <div className="Priv-content-box">
              <br></br>
              <br></br>
              <h4>Goal PS1:</h4>
              <h3>Privacy Standard compliance</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        
          <div className="stats-box" onClick={() => openModal('Security Policy compliance')}>
            <div className="icon-box blue">
              <FaUniversalAccess />
            </div>
            <div className="Priv-content-box">
              <br></br>
              <br></br>
              <h4>Goal PS2:</h4>
              <h3>Security Policy compliance</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        </div>
        {/* Modal for displaying the questions with recommendations */}
        <DashModal isOpen={isDashModalOpen} onClose={closeModal} selectedGroup={selectedGroup} />
      </div>
    </div>
  );
};

    

export default Privacy;